export const OPTION_ORDER_TYPES = [
  "market",
  "limit",
  "stop",
  "stop_limit",
] as const;
export type OptionOrderType = (typeof OPTION_ORDER_TYPES)[number];

export const OPTION_TIME_IN_FORCE = ["day", "gtc"] as const;
export type OptionTimeInForce = (typeof OPTION_TIME_IN_FORCE)[number];

export const POSITION_INTENT = [
  "buy_to_open",
  "buy_to_close",
  "sell_to_open",
  "sell_to_close",
] as const;
export type PositionIntent = (typeof POSITION_INTENT)[number];

/**
 * Options fee constants from the Alpaca Brokerage Fee Schedule (revised 2026-03-24).
 * Source: https://files.alpaca.markets/disclosures/library/BrokFeeSched.pdf
 * These are hardcoded estimates and will drift as rates change.
 */

/** OCC clearing fee per contract. Buys and sells. Capped at OCC_CONTRACT_CAP contracts per trade. */
export const OCC_CLEARING_FEE = 0.025;
/** Max contracts subject to OCC clearing fee per trade. Source: Alpaca docs "up to 2750 contracts". */
export const OCC_CONTRACT_CAP = 2750;
/** Options Regulatory Fee (ORF) per contract. Buys and sells. */
export const OPTIONS_REGULATORY_FEE = 0.02295;
/** FINRA Trading Activity Fee (TAF) per contract. Sells only. */
export const OPTIONS_TAF_FEE = 0.00329;
/** Consolidated Audit Trail (CAT) fee per executed equivalent share (EES). */
export const OPTIONS_CAT_FEE_PER_EES = 0.000022;
/** Standard options contract multiplier (1 contract = 100 shares). Used for EES calculation. */
export const OPTIONS_MULTIPLIER = 100;
/** Default contract multiplier as a string, for fallback when contract data is unavailable. */
export const DEFAULT_CONTRACT_MULTIPLIER = "100";

export const LOCALE_OPTIONS = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

export const LOCALE_OPTIONS_PRECISE = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 4,
};

export const POSITION_INTENT_OPTIONS: {
  value: PositionIntent;
  label: string;
  side: "buy" | "sell";
}[] = [
  { value: "buy_to_open", label: "Buy to Open", side: "buy" },
  { value: "buy_to_close", label: "Buy to Close", side: "buy" },
  { value: "sell_to_open", label: "Sell to Open", side: "sell" },
  { value: "sell_to_close", label: "Sell to Close", side: "sell" },
];

export const OPTION_ORDER_TYPE_OPTIONS: {
  value: OptionOrderType;
  label: string;
}[] = [
  { value: "market", label: "Market" },
  { value: "limit", label: "Limit" },
  { value: "stop", label: "Stop" },
  { value: "stop_limit", label: "Stop Limit" },
];

export const OPTION_TIME_IN_FORCE_OPTIONS: {
  label: string;
  subLabel?: string;
  value: OptionTimeInForce;
  orderTypes: OptionOrderType[];
}[] = [
  {
    label: "Day",
    value: "day",
    orderTypes: ["market", "limit", "stop", "stop_limit"],
  },
  {
    label: "GTC",
    subLabel: "Expires in 90 days",
    value: "gtc",
    orderTypes: ["market", "limit", "stop", "stop_limit"],
  },
];
